<div class="white-box main-black">
	<div class="col-sm-6 col-md-12 col-lg-2 text-right ml-auto pt-4">
		<button class="btn btn-primary" (click)="exportReports()">{{'g.export' | translate}}</button>
	</div>

	<div class="white-box main-black mt-4 p-4 border-radius">
		<div class="col-sm-6 col-md-6 title">
			<h4>
				{{"iotemeter.site.meter_disconnection_report" | translate }}
				<app-help-tooltip [field]="'meter_disconnection_report'"></app-help-tooltip>
			</h4>
		</div>
		<sct-custom-table
			[columnsConfig]="meterDisconnectionReportTableConfig.column"
			[data]="meterDisconnectionReportTableConfig.data"
			[config]="meterDisconnectionReportTableConfig.config"
		>
		</sct-custom-table>
	</div>

	<div class="col-md-6 col-md-3 col-lg-2 p-4">
		<label for="period">{{"perf_analytic.period" | translate}}</label>
		<ng-select
			id="period"
			class="select"
			[items]="periods"
			[addTag]="false"
			[clearable]="false"
			[searchable]="false"
			bindLabel="label"
			bindValue="value"
			(change)="getData()"
			[placeholder]="'g.durations' | translate"
			[(ngModel)]="selectedPeriod"
		></ng-select>
	</div>


	<div class="white-box main-black mt-4 p-4 border-radius">
		<div class="col-sm-6 col-md-6 title">
			<h4>
				{{"iotemeter.site.low_meter_kWh_utilization_report" | translate }}
				<app-help-tooltip [field]="'low_meter_kWh_utilization_report'"></app-help-tooltip>
			</h4>
		</div>
		<sct-custom-table
			[columnsConfig]="lowMeterkWhUtilizationReportTableConfig.column"
			[data]="lowMeterkWhUtilizationReportTableConfig.data"
			[config]="lowMeterkWhUtilizationReportTableConfig.config"
		>
		</sct-custom-table>
	</div>


	<div class="white-box main-black mt-4 p-4 border-radius">
		<div class="col-sm-6 col-md-6 title">
			<h4>
				{{"iotemeter.site.high_daily_kw_demand_report" | translate }}
				<app-help-tooltip [field]="'high_daily_kw_demand_report'"></app-help-tooltip>
			</h4>
		</div>
		<sct-custom-table
			[columnsConfig]="highDailyKwDemandReportTableConfig.column"
			[data]="highDailyKwDemandReportTableConfig.data"
			[config]="highDailyKwDemandReportTableConfig.config"
		>
		</sct-custom-table>
	</div>
</div>



